import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import { fufillmentDetailModel } from "@/models/fulfillment/fulfillment-detail";
import store from "@/store";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useFulfillmentList() {
  const { getPermissionModule } = usePermissionByAccount()
  const {
    fetchTableFulfillmentList,
    editFulfillmentDetail,
  } = fufillmentDetailModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const { openModal, closeModal } = useModal();

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
    openErrorModal,
  } = useValidationModal();

  const { resolveDate, resolveFullTime } = useFlatPickr();

  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };

  const loading = reactive({
    tableData: false,
    formData: false,
  });

  const modalType = reactive({
    reorder: false,
    manageShippingDetail: false,
  });

  const shippingDetailObj = reactive({
    selectId: 0,
  });

  const isEditData = ref(false);

  const resolveShippingStatus = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "Preparing";
      case 5:
        return "Packed";
      case 7:
        return "Shipped";
      case 9:
        return "Received";
      default:
        return "-";
    }
  };

  const resolveClassShippingStatus = (status) => {
    switch (status) {
      case 1:
        return "pending";
      case 2:
        return "preparing";
      case 5:
        return "preparing";
      case 7:
        return "shipping";
      case 9:
        return "recived";
      default:
    }
  };

  const openShippingDetailModal = (selectId, isEdit) => {
    isEditData.value = false;
    if (selectId && isEdit == true) {
      isEditData.value = true;
      shippingDetailObj.selectId = selectId;
    }

    modalType.manageShippingDetail = true;
    openModal();
  };

  const closeShippingDetailModal = () => {
    modalType.manageShippingDetail = false;
    closeModal();
  };

  const validateBeforeSubmitFulfillment = (inputData) => {
    if (inputData.trackNo) {
      if (!inputData.logisticValue) {
        openErrorModal("เกิดข้อผิดพลาด", "กรุณาเลือก Logistic Company");
        return true;
      }
    }

    if (inputData.logisticValue) {
      if (!inputData.trackNo) {
        openErrorModal("เกิดข้อผิดพลาด", "กรุณาระบุ Tracking No.");
        return true;
      }
    }

    return false;
  };

  const saveDataModal = (inputData, isEditModal = false) => {
    if (validateBeforeSubmitFulfillment(inputData)) return;
    window.$loading(true);
    loading.formData = true;

    const payload = {
      Ticket_Id: inputData.ticketId,
      Status: inputData.statusShipping,
      Tracking_No: inputData.trackNo,
      Shipping_Company: inputData.logisticValue,
      Shipping_Id: inputData.shippingId,
      Shipping_Tracking_Url: inputData.trackUrl,
      FFM_Detail: inputData.detail,
      FFM_Ref: inputData.ffm_reference,
      // Title: "นาย",
      First_Name: inputData.firstName,
      Last_Name: inputData.lastName,
      Address: inputData.address,
      HouseNo: inputData.houseNo,
      VillageNo: inputData.villageNo,
      Lane: inputData.lane,
      Building: inputData.buildingNo,
      Street: inputData.street,
      SubDistrictId:
        inputData.subDisrtrict == inputData.previous.subDistrict
          ? inputData.subDisrtrictId
          : null,
      SubDistrict: inputData.subDisrtrict,
      DistrictId:
        inputData.district == inputData.previous.district
          ? inputData.districtId
          : null,
      District: inputData.district,
      ProvinceId:
        inputData.province == inputData.previous.province
          ? inputData.provinceId
          : null,
      Province: inputData.province,
      // CountryId: inputData.countryId,
      // Country: inputData.country,
      PostalCode: inputData.postalCode,
      Addr_Remark: inputData.remarkAddress,
      ContactNo: String(inputData.contactNo).replace(/\D/g, ""),
      Lang_Code: "",
      Extra_Ref: inputData.extraRef,
      Extra_Ref_2: inputData.extraRef2,
      Is_Update_Address: true,
    };

    if (isEditModal) {
      editFulfillmentDetail.payload = payload;

      store
        .dispatch("api/apiRequest", editFulfillmentDetail)
        .then((resp) => {
          modalType.manageShippingDetail = false;
          fetchFulfillmentList();
          closeModal();
        })
        .catch((err) => {
          openDefaultErrorModal();
        })
        .finally(() => {
          window.$loading(false);
          loading.formData = false;
        });
    }
  };

  const fields = [
    // { key: "seq", label: "No" },
    { key: "ffm_reference", label: "Ref" },
    { key: "mobile_no", label: "Mobile No." },
    { key: "first_name", label: "First Name" },
    { key: "last_name", label: "Last Name" },
    { key: "privilege_type", label: "Privilege Type" },
    { key: "privilege_name_th", label: "Privilege Name" },
    { key: "transaction_txref", label: "Transaction Ref." },
    { key: "privilege_alt_ref", label: "Privilege Ref." },
    { key: "qty", label: "Qty." },
    { key: "point_total", label: "Point Burn" },
    { key: "issue_date", label: "Issue Date" },
    { key: "updated_dt", label: "Latest Update" },
    { key: "shipping_status", label: "Shipping Status" },
    { key: "actions", label: "" },
  ];

  const statusOption = ref([
    { label: "Not Specified", labelTh: "ไม่ระบุ", value: 0 },
    { label: "Pending", labelTh: "รอดำเนินการ", value: 1 },
    { label: "Preparing", labelTh: "กำลังเตรียม", value: 2 },
    { label: "Packed", labelTh: "บรรจุแล้ว", value: 5 },
    { label: "Shipped", labelTh: "จัดส่งแล้ว", value: 7 },
    { label: "Received", labelTh: "ได้รับแล้ว", value: 9 },
  ]);

  const form = reactive({
    status: null,
  });

  const fulfillmentListTable = reactive({
    payload: [],
  });

  const fetchFulfillmentList = () => {
    loading.tableData = true;
    fetchTableFulfillmentList.payload.Page = pagination.currentPage;
    fetchTableFulfillmentList.payload.Limit = pagination.perPage;
    fetchTableFulfillmentList.payload.Filters = filters;
    fetchTableFulfillmentList.payload.Ordering = ordering.value;

    store
      .dispatch("api/apiRequest", fetchTableFulfillmentList)
      .then((response) => {
        fulfillmentListTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchFulfillmentList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchFulfillmentList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    fetchFulfillmentList();
  });

  return {
    fields,
    loading,
    statusOption,
    form,
    fulfillmentListTable,
    pagination,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
    fetchFulfillmentList,

    isEditData,
    modalType,
    shippingDetailObj,
    openShippingDetailModal,
    closeShippingDetailModal,
    saveDataModal,
    resolveShippingStatus,
    resolveClassShippingStatus,
    resolveDate,
    resolveFullTime,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
    getPermissionModule
  };
}
